import { render, staticRenderFns } from "./RefAutocomplete.vue?vue&type=template&id=2640c90a&"
import script from "./RefAutocomplete.vue?vue&type=script&lang=js&"
export * from "./RefAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports